<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="qualityControl-box">
      <div class="center-box">
        <div class="qualityControl-box">
          <div class="crumbs">{{ pageType == 1 ? '首页 > 质控网络 > 质控网络详情' : '首页 > 质控公告 > 质控公告详情' }}</div>
          <!-- 渲染富文本内容 -->
          <div class="richText">
            <div class="richText-content" v-if="newsContent">
<!--              <quill-editor v-model:content="newsContent" :options="editorOption" contentType="html" readonly @focus="onEditorFocus($event)" @change="onEditorChange($event)" />-->
              <div class="richText-html" v-html="newsContent"></div>
            </div>
            <!-- 渲染富文本内容 -->
            <div class="video-box" v-if="imageType === 1">
              <video :src="videoUrl.url" controls />
            </div>
            <div class="" v-if="imageType === 2 || imageType === 3 || imageType === 4">
              <div v-for="(item, index) in pdfContent" :key="index">
                <VueOfficePdf v-if="imageType === 2 || imageType === 3" :src="item.url" />
                <VueOfficeDocx v-else-if="imageType === 4" :src="item.url" />
              </div>
            </div>
<!--            <div class="accessory-box" v-if="pageType != 1">-->
<!--              <div class="accessory-head">附件操作</div>-->
<!--              <div class="accessory-ul">-->
<!--                <div class="accessory-li" v-for="(item, index) in pdfFile" :key="index">-->
<!--                  <div class="accessory-left">-->
<!--                    <img src="@/assets/images/yulan.png" />-->
<!--                    <div class="accessory-title">{{ item.name }}</div>-->
<!--                  </div>-->
<!--                  <div class="accessory-right">-->
<!--                    &lt;!&ndash; <div class="accessory-bt" @click="watchFile(item)">预览</div> &ndash;&gt;-->
<!--                    <div class="accessory-bt active" @click="downloadFile(item)">下载</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
    <FilePreview v-if="showModal" :showModal="showModal" :file="file" @close="[(showModal = false), (file = { name: '', url: '' })]"></FilePreview>
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import comment from "@/components/base/comment"
import FilePreview from "@/components/base/FilePreview"
import { getPageDetails, getQualityControlDetails } from '@/api/home'
// 引入vue-quill-editor
import { quillEditor } from "vue-quill-editor";
import VueOfficePdf from "@vue-office/pdf";
import VueOfficeDocx from "@vue-office/docx";
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, comment, FilePreview, quillEditor, VueOfficePdf, VueOfficeDocx },
  data() {
    return {
      selectedIndex: 5,
      newsContent: '', // 用来存储富文本内容
      id: '',
      pdfFile: [], // 附件
      showModal: false,
      file: {
        name: '',
        url: ''
      },
      pageType: '',
      editorOption: {
        theme: 'snow', // 主题风格
        modules: {
          toolbar: false, // 设置为false以隐藏工具栏
        },
        readOnly: true, // 禁止编辑
        // bounds: document.body,
        debug: 'warn',
      },
      imageType: '',
      pdfContent: [],
      videoUrl: {}
    }
  },
  methods: {
    gotoNews() {
      this.$router.push('/NewsCenter')
    },
    onEditorFocus(editor) {
      editor.enable(false);
    },
    onEditorChange(editor) {
      editor.quill.enable(false);
    },
    // 模拟获取富文本的内容
    fetchNewsContent() {
      // 模拟从后端获取富文本内容
      // 这里假设从后端接口获取到了 HTML 格式的富文本
      const imageUrl = require('@/assets/images/z1.png');
      const content = `
          <h2>10.17第一次全国耳鼻咽喉科质控工作会议</h2>
          <p>2024-10-30。</p>
          <p style="line-height: 24px;">2024年10月17日，全国耳鼻咽喉科专业医疗质量控制工作会议在合肥召开，由复旦大学附属眼耳鼻喉科医院和北京同仁医院主办，百余位专家参会，参会代表包括全国耳鼻咽喉科质控专家委员会委员、各省级质控中心主任和各亚专业质控专家组成员。聚焦医疗质量管理标准化建设以提升诊疗与服务质量。
会议由国家耳鼻咽喉科专业医疗质量控制中心秘书许信达和王梦琳共同主持。大会伊始，国家耳鼻咽喉科专业医疗质量控制中心主任李文妍教授首先致辞，她回顾了中心自成立以来的工作进展，阐述了未来的发展规划。作为国家卫健委医政司委托复旦大学附属眼耳鼻喉科医院和北京同仁医院共同筹建的国家级质控平台，该中心肩负着提升耳鼻咽喉科医疗质量管理与控制的重要使命。未来，中心将继续完善质控体系建设，推动行业高质量发展，为提升全国耳鼻咽喉科诊疗水平提供有力保障。
国家耳鼻咽喉科专业医疗质量控制中心主任，北京同仁医院党委副书记、院长张罗教授对质控中心的建设情况进行了阶段性工作总结，并反馈了2024年度全国耳鼻咽喉科医疗质量调研的工作成果。他强调，质控中心自筹建以来，得益于各方的支持和努力，逐步构建了科学化、标准化的质量工作机制，为全国耳鼻咽喉科医疗质量的提升奠定了坚实基础。展望未来，他表示中心将继续整合行业资源，凝聚力量，推动全国耳鼻咽喉科医疗质量的持续优化和提升。同时，张罗教授也对本次会议寄予厚望，期盼与各位专家深入探讨耳鼻咽喉科专业质控指标，共同为推动行业高质量发展建言献策。
中华医学会耳鼻咽喉头颈外科学分会主任委员、全国耳鼻咽喉科质控专家委员会委员、头颈外科专业质控专家组组长黄志刚教授也出席本次会议并致辞，黄志刚教授肯定了质控中心在推动全国医疗质量提升中发挥的关键作用，并期待未来中心能够在技术创新、标准制定和人才培养等方面取得更多突破，同时也强调建立全国哨点医院网络对推动质控工作的重要作用。
全国耳鼻咽喉科质控专家委员会委员、咽喉科专业质控专家组组长、复旦大学附属眼耳鼻喉科医院副院长邵骏教授在致辞中表达了对质控中心未来发展的期盼。他指出，质控中心的成立不仅是国家医疗质量管理体系的重要一环，更是推动耳鼻咽喉科专业服务质量跃升的关键力量，未来必将带动整个行业迈向新的高度。
随后，耳科、鼻科、咽喉科及头颈外科四个专业组分别进入分组讨论环节，各亚专业质控专家组就各自领域质控现状、质控指标体系建立及未来的改进方向进行了深入交流与讨论。
深度探讨 建言献策
在鼻科专业组研讨会上，全国耳鼻咽喉科质控专家委员会委员、鼻科专业质控专家组副组长、北京同仁医院副院长王成硕教授主持并汇报。王成硕教授结合全国大数据分析结果，深入剖析了目前鼻科学领域医疗服务能力现状。他指出，未来鼻科专业质控方向将围绕鼻科常见五大疾病（慢性鼻窦炎、过敏性鼻炎、鼻内翻性乳头状瘤、鼻出血、鼻中隔偏曲），聚焦鼻内镜关键诊疗技术，开展医疗质量提升工作。同时，王成硕教授重点介绍了初步拟定的十三项鼻科质控指标，这些指标涵盖慢性鼻窦炎、鼻内翻性乳头状瘤、鼻内镜手术等关键领域，旨在推动医疗机构规范诊疗，提升患者预后和医疗服务质量。
随后，质控指标的讨论环节由张罗教授主持。与会专家们纷纷踊跃发言，针对质控指标的实际应用、如何通过细化标准提升诊疗效果等问题展开了深入探讨。在张罗教授的引导下，专家们结合自身的临床经验，分析了指标推行中可能遇到的困难和挑战，并探讨了指标改进方案。会议室中充满了智慧的碰撞与思维的交锋。为鼻科质控体系的进一步完善奠定了基础，各方专家的积极参与和热烈讨论，为推动全国鼻科医疗质量的不断提升注入了新的动力。
专家齐聚 共促提升
头颈外科专业组研讨会由全国耳鼻咽喉科质控专家委员会委员、头颈外科专业质控专家组副组长、中国医学科学院肿瘤医院刘绍严教授主持。黄志刚教授（职务同上）致辞，指出头颈肿瘤疾病复杂、涉及多学科合作，基层诊疗水平待提升，质控工作挑战大且意义重大。
随后，全国耳鼻咽喉科质控专家委员会委员、头颈外科专业质控专家组副组长、北京同仁医院陈晓红教授总结专业组阶段性工作并提未来计划。他强调喉癌等头颈部恶性肿瘤发病率高、各地诊疗水平差异大，质控任务繁重，还重点阐述质控难点及解读十二项质控指标内涵意义，希望专家讨论完善指标，制定适合我国的关键标准。讨论环节，专家们热烈讨论质控指标，积极提修改意见建议。
最后，黄志刚教授对本次会议进行了总结，指出此次讨论为未来头颈外科质控工作的开展奠定了坚实基础，期待与会专家继续支持质控工作的实施，推动我国头颈肿瘤诊疗水平的提升与规范</p>
        `;
      this.newsContent = content; // 将内容赋值给 newsContent
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails() {
      getPageDetails({
        id: this.id
      }).then(res => {
        this.imageType = res.data[0].imageType
        this.newsContent = res.data[0].htmlContent
        this.pdfFile = res.data[0].pdfFile
        if (this.imageType === 1) {
          this.videoUrl = res.data[0].video
        } else if (this.imageType === 2) {
          this.pdfContent = res.data[0].pdfFile
        } else if (this.imageType === 3) {
          this.newsContent = res.data[0].htmlContent
          this.pdfContent = res.data[0].pdfFile
        } else if (this.imageType === 4) {
          this.pdfContent = res.data[0].wordFile
        } else if (this.imageType === 0) {
          this.newsContent = res.data[0].htmlContent
        }
      })
    },
    // 按 id 查询分级质控
    getQualityControlDetails() {
      getQualityControlDetails({
        id: this.id
      }).then(res => {
        this.newsContent = this.convertLinksToImages(res.data[0].description)
      })
    },
    async fetchAttachment(url) {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch attachment');
      return response.blob();
    },
    async downloadFile(file) {
      if (file != undefined) {
        try {
          const blob = await this.fetchAttachment(file.url);
          const url = URL.createObjectURL(blob);

          // 创建下载链接并触发点击
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = file.name; // 自定义下载文件名
          downloadLink.style.display = 'none';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          // 释放URL引用
          setTimeout(() => URL.revokeObjectURL(url), 0);
        } catch (error) {
          console.error('Error downloading attachment:', error);
        }
      }
    },
    convertLinksToImages(text) {
      const imgRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
      text = text.replace(imgRegex, '<img src="$2" alt="$1">');
      return text.replace(/\n/g, '<br>');
    },
    watchFile(file) {
      this.file.name = file.name;
      this.file.url = file.url;
      this.showModal = true;
    },
  },
  mounted() {
    // this.fetchNewsContent(); // 页面加载后获取富文本内容
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.id = this.$route.params.id
    if (this.$route.query.type) {
      this.pageType = this.$route.query.type
      this.getQualityControlDetails()
    } else {
      this.selectedIndex = 6
      this.getPageDetails()
    }
  }
}
</script>
<style lang="less">
.richText-html {
  line-height: 30px;
  font-size: 16px;
  white-space: normal; /* ← 更适合 HTML 内容 */
  word-break: break-word;
  text-align: left;
}
</style>
<style lang="less" scoped>
.center-box {
  padding-bottom: 80px;
}

.accessory-box {
  width: 1150px;
  margin: auto;
  margin-top: 40px;

  .accessory-head {
    color: #222222;
    font-size: 18px;
    line-height: 26px;
    text-align: left;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .accessory-li:last-child {
    border-bottom: none;
  }

  .accessory-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.6px solid rgba(232, 232, 232, 1);
    height: 50px;

    .accessory-right {
      display: flex;
      align-items: center;

      .accessory-bt.active {
        color: #BD181E;
        border: 1px solid #BD181E;
        background: #fff;
      }

      .accessory-bt {
        cursor: pointer;
        background: rgba(245, 245, 245, 1);
        border: 1px solid rgba(245, 245, 245, 1);
        width: 62px;
        height: 24px;
        border-radius: 4px;
        font-size: 12px;
        color: #222222;
        line-height: 24px;
        margin-left: 10px;
      }
    }

    .accessory-left {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #222222;
      font-weight: bold;

      img {
        width: 30px;
        margin-right: 7px;
      }
    }
  }
}

.richText {
  background: #fff;
  border-radius: 6px;
  padding: 40px 60px;
  margin-top: 18px;

  .richText-content {
    /deep/ .ql-container.ql-snow {
      border: none;
    }
  }

  .richText-html {
    width: 100%;

    /deep/ img {
      max-width: 100%;
    }
  }

  // img {
  //   width: 600px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/QualityControlDetails/index.vue